import JamEventOnboarding from '@/src/components/game/JamEventOnboarding/JamEventOnboarding';
import React from 'react';

export const JamEventTeamJoinPage: React.FC = () => {
  return <JamEventOnboarding />;
};
